/**
 * Per-page Open Graph image resolution.
 *
 * Instead of every route sharing a single /og-image.jpg, each section gets its
 * own branded card, and content routes (blog posts, category listings) prefer
 * real content imagery so shared links look unique.
 */

export const OG_IMAGE_COURSES = '/og-courses.jpg';
export const OG_IMAGE_BLOG = '/og-blog.jpg';

/** Generic placeholder used by the course listing hook when a course has no image. */
const COURSE_IMAGE_PLACEHOLDER = '/lovable-uploads/260cc990-4144-41b4-9b20-498353be10d8.png';

const isUsableImage = (image?: string | null): image is string =>
  Boolean(image && image.trim() && image !== COURSE_IMAGE_PLACEHOLDER);

/**
 * OG image for /courses and category listings.
 * Category pages use the first course image in that category so each category
 * shares a distinct thumbnail; falls back to the branded courses card.
 */
export const resolveCoursesOgImage = (
  isCategoryView: boolean,
  courses: Array<{ image?: string | null }>,
): string => {
  if (isCategoryView) {
    const withImage = courses.find((course) => isUsableImage(course.image));
    if (withImage) return withImage.image as string;
  }
  return OG_IMAGE_COURSES;
};

/** OG image for a single blog post — its own artwork, else the branded blog card. */
export const resolveBlogPostOgImage = (
  ogImage?: string | null,
  featuredImage?: string | null,
): string => {
  if (isUsableImage(ogImage)) return ogImage;
  if (isUsableImage(featuredImage)) return featuredImage;
  return OG_IMAGE_BLOG;
};
